import { render } from "./join-in.vue?vue&type=template&id=82d9619c"
import script from "./join-in.vue?vue&type=script&lang=js"
export * from "./join-in.vue?vue&type=script&lang=js"

import "./join-in.vue?vue&type=style&index=0&id=82d9619c&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__